<template>
    <ion-toolbar>
        <slot>
            <ion-title>
                Footer
            </ion-title>
        </slot>
    </ion-toolbar>
</template>

<script setup lang="ts">
import { IonTitle, IonToolbar } from '@ionic/vue'
</script>

<style scoped>
.toolbar-background {
    background-color: var(--ion-toolbar-background);
}
</style>
